import React from 'react';
import styled from 'styled-components';
import { cores } from '../../../../styles/styleUtils';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableWrapper = styled.div`
  height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const Th = styled.th`
  background-color: ${cores.cinzaClaro};
  padding: 10px;
  text-align: left;
`;

const Td = styled.td`
  padding: 10px;
  border-bottom: 1px solid ${cores.cinzaClaro};
`;

const Tr = styled.tr`
  background-color: ${({ selected }) => (selected ? cores.cinzaClaro : cores.branco)};
`;

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Checkbox = styled.input`
  margin: 0;
  cursor: pointer;
`;

const getValueByPath = (obj, path) => {
  try {
    return path.split('.').reduce((acc, part) => acc?.[part], obj) ?? '';
  } catch {
    return '';
  }
};

const getFormattedValue = (obj, field) => {
  const value = getValueByPath(obj, field.path);

  if (value === undefined || value === null) return '';

  switch (field.type) {
    case 'date':
      return new Date(value).toLocaleDateString();
    case 'currency':
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    default:
      return value;
  }
};

// Props alteradas: 'selectedId' e 'onCancel' foram removidos
// e 'selectedIds' foi adicionado.
const DocumentTable = ({ data, selectedIds = [], onSelect, titles, fields }) => {
  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            <Th />
            {titles.map((title, idx) => (
              <Th key={idx}>{title}</Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((doc) => {
            // Verifica se o ID do documento atual está no array de IDs selecionados
            const isSelected = selectedIds.includes(doc._id);
            return (
              <Tr key={doc._id} selected={isSelected}>
                <Td>
                  <CheckboxWrapper>
                    <Checkbox
                      type="checkbox"
                      // O estado 'checked' agora depende se o ID está no array
                      checked={isSelected}
                      // A função onSelect agora é chamada diretamente,
                      // o componente pai cuidará da lógica de adicionar/remover
                      onChange={() => onSelect(doc)}
                    />
                  </CheckboxWrapper>
                </Td>
                {fields.map((field, idx) => (
                  <Td key={idx}>{getFormattedValue(doc, field)}</Td>
                ))}
              </Tr>
            );
          })}
        </tbody>
      </Table>
    </TableWrapper>
  );
};

export default DocumentTable;